function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L119 0L119 45L0 45L0 0Z",
  id: "go_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "go_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#go_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "go-logo-blue-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L119 0L119 45L0 45L0 0Z",
  id: "go-logo-blue-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#go_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.40234375 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.0574877 1.84615L1.26473 0.288461C1.37971 0.115385 1.66715 0 1.8971 0L22.4203 0C22.6502 0 22.7077 0.173077 22.5928 0.346154L21.6155 1.84615C21.5005 2.01923 21.213 2.19231 21.0406 2.19231L0.229952 2.13461C4.79717e-07 2.13461 -0.0574881 2.01923 0.0574877 1.84615Z",
  transform: "translate(8.680664 11.269531)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.0574879 1.84615L1.26473 0.288461C1.37971 0.115385 1.66715 0 1.8971 0L28.1116 0C28.3415 0 28.4565 0.173077 28.399 0.346154L27.9391 1.73077C27.8816 1.96154 27.6517 2.07692 27.4217 2.07692L0.229952 2.13461C0 2.13461 -0.0574879 2.01923 0.0574879 1.84615Z",
  transform: "translate(0 16.577148)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.0574881 1.78846L0.862319 0.346155C0.977295 0.173078 1.20725 0 1.4372 0L12.9348 0C13.1647 0 13.2797 0.173077 13.2797 0.403847L13.1647 1.78846C13.1647 2.01923 12.9348 2.19231 12.7623 2.19231L0.229951 2.13462C-3.25522e-07 2.13462 -0.0574878 1.96154 0.0574881 1.78846Z",
  transform: "translate(13.912109 21.884766)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(31.339844 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.817 14.9044C31.9547 15.1352 31.8972 15.1929 31.1499 14.3275C30.2876 13.3467 29.6552 12.7121 28.4479 12.1352C24.8262 10.3467 21.3194 10.866 18.0426 13.0006C14.1335 15.539 12.1214 19.289 12.1789 23.9621C12.2363 28.5775 15.3982 32.3852 19.9397 33.0198C23.8489 33.539 27.1257 32.1544 29.7127 29.2121C30.2301 28.5775 30.69 27.8852 31.2649 27.0775C29.1953 27.0775 26.6083 27.0775 20.1697 27.0775C18.9624 27.0775 18.675 26.3275 19.0774 25.3467C19.8248 23.5583 21.2045 20.5583 22.0093 19.0583C22.1818 18.7121 22.5842 18.1352 23.4465 18.1352L44.3721 18.1352C44.2571 19.6929 44.2571 21.2506 44.0272 22.8083C43.3948 26.9621 41.8426 30.7698 39.3132 34.116C35.174 39.5967 29.7702 43.0006 22.9291 43.9236C17.2953 44.6736 12.0639 43.5775 7.46485 40.116C3.21074 36.8852 0.79625 32.616 0.163882 27.3083C-0.583461 21.0198 1.25615 15.366 5.05036 10.4044C9.132 5.03903 14.5359 1.63519 21.147 0.42365C26.5508 -0.557119 31.7248 0.0774963 36.3813 3.25057C39.4281 5.2698 41.6127 8.03904 43.0499 11.3852C43.3948 11.9044 43.1649 12.1929 42.475 12.366L42.475 12.366C38.8533 13.289 36.3813 13.9813 32.817 14.9044Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.49822 38.6587C3.10643 35.7164 0.979374 31.9664 0.289519 27.524C-0.745264 21.0048 1.03686 15.2356 4.94604 10.101C9.14266 4.56251 14.2016 1.67789 21.0427 0.466352C26.9064 -0.57211 32.4253 0.0048134 37.4267 3.40866C41.9683 6.52404 44.7852 10.7356 45.5325 16.274C46.5098 24.0625 44.2678 30.4087 38.9214 35.8317C35.1272 39.6971 30.4707 42.1202 25.1243 43.2164C23.5721 43.5048 22.02 43.5625 20.5253 43.7356L20.5253 43.7356C15.2939 43.6202 10.5224 42.1202 6.49822 38.6587ZM34.0349 18.524C33.0001 12.8125 27.7687 9.58174 22.3074 10.851C16.961 12.0625 13.5117 15.4664 12.247 20.8894C11.2122 25.3894 13.3968 29.9471 17.5359 31.7933C20.6977 33.1779 23.8596 33.0048 26.9064 31.4471C31.448 29.0817 33.92 25.3894 34.2074 20.4279L34.2074 20.4279C34.1499 19.6779 34.1499 19.101 34.0349 18.524Z",
  transform: "translate(40.978516 0.5341797)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgGo = function SvgGo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "45px",
    viewBox: "0 0 119 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/go.fc557e28.svg";
export { ForwardRef as ReactComponent };